// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"47":"2cbeaf67","790":"be9e6ca5","871":"1bc7c805","953":"dcc93bca"}[chunkId] + ".css";
};